module.exports = __webpack_public_path__ + "img/shape-modal.25d393f2.svg";